const HOMEWORK_DONE = 4;

const isDone = (block) => Number(block?.homework_icon_color) === HOMEWORK_DONE;

const findCurrentHomeworkIndex = (blocks, blockId, attemptId) => {
  const byAttempt = attemptId
    ? blocks.findIndex((block) => Number(block.el_homework_block_id) === Number(attemptId))
    : -1;

  if (byAttempt >= 0) return byAttempt;

  return blockId ? blocks.findIndex((block) => Number(block.id) === Number(blockId)) : -1;
};

export function findNextHomeworkBlock(blocks, blockId, attemptId) {
  if (!Array.isArray(blocks) || blocks.length === 0) return null;

  const current = findCurrentHomeworkIndex(blocks, blockId, attemptId);

  return current < 0 ? null : blocks[current + 1] || null;
}

export function findFirstOpenHomeworkBlock(blocks) {
  if (!Array.isArray(blocks)) return null;

  return blocks.find((block) => !isDone(block)) || null;
}
